// Общие вопросы
export const generalQuestions = [
  { 
    q: 'Что такое AvatarMe?', 
    a: 'AvatarMe — это комплексная платформа для управления всеми аспектами жизни: финансами, здоровьем, семьёй и целями в одном месте.' 
  },
  { 
    q: 'Как начать работу?', 
    a: 'Сервис используется в частном режиме. Публичная регистрация закрыта; вход доступен для существующих аккаунтов.'
  },
  { 
    q: 'Нужно ли устанавливать приложение?', 
    a: 'Нет, AvatarMe — это веб-приложение, которое работает в браузере на любом устройстве.' 
  }
];

// Финансы
export const financeQuestions = [
  { 
    q: 'Как отслеживать доходы и расходы?', 
    a: 'В разделе "Финансы" вы можете добавлять транзакции, категоризировать их и видеть баланс в реальном времени. Система автоматически рассчитывает ваш текущий баланс.' 
  },
  { 
    q: 'Поддерживается ли учёт инвестиций?', 
    a: 'Да! Вы можете добавлять инвестиционные портфели, отслеживать активы (акции, облигации, валюты) с автоматическим обновлением цен через Yahoo Finance и MOEX.' 
  },
  { 
    q: 'Можно ли импортировать банковские выписки?', 
    a: 'В разработке находится функционал импорта CSV-файлов от популярных банков для автоматического заполнения транзакций.' 
  }
];

// Цели и задачи
export const goalsQuestions = [
  { 
    q: 'Как работает дерево целей?', 
    a: 'Создавайте иерархию целей: жизненные категории → проекты → цели → подцели → задачи. Визуализация в виде дерева помогает видеть картину целиком и связи между целями.' 
  },
  { 
    q: 'Что такое канбан-доска задач?', 
    a: 'Каждая цель имеет доску с колонками: Запланировано, В процессе, Готово, Архив. Перетаскивайте задачи между колонками для отслеживания прогресса.' 
  },
  { 
    q: 'Можно ли устанавливать дедлайны?', 
    a: 'Да! Для каждой цели и задачи можно указать дату начала и дедлайн. Система будет отслеживать прогресс и показывать просроченные задачи.' 
  },
  { 
    q: 'Как работает архивирование задач?', 
    a: 'При архивировании можно указать дату фактического завершения — это полезно для импорта исторических данных и точной статистики.' 
  }
];

// Семья
export const familyQuestions = [
  { 
    q: 'Как добавить членов семьи?', 
    a: 'В разделе "Семья" вы можете добавлять членов семьи с указанием имени, даты рождения и родственных связей.' 
  },
  { 
    q: 'Что можно отслеживать для семьи?', 
    a: 'Семейные события (дни рождения, годовщины), активности (поездки, праздники), а также общие семейные цели.' 
  }
];

// Здоровье
export const healthQuestions = [
  { 
    q: 'Какие показатели здоровья можно отслеживать?', 
    a: 'Функционал здоровья находится в разработке. Планируется учёт веса, физической активности, сна и общего самочувствия.' 
  }
];

// Безопасность
export const securityQuestions = [
  { 
    q: 'Безопасны ли мои данные?', 
    a: 'Да! Все данные зашифрованы при передаче (HTTPS), пароли хэшируются с использованием bcrypt, а доступ защищён JWT-токенами. Мы не передаём ваши данные третьим лицам.' 
  },
  { 
    q: 'Кто имеет доступ к моим данным?', 
    a: 'Только вы. Данные хранятся на защищённом сервере и доступны исключительно через вашу учётную запись.' 
  },
  { 
    q: 'Можно ли экспортировать данные?', 
    a: 'Функционал экспорта данных в JSON/CSV формате находится в разработке.' 
  }
];

// Аналитика
export const analyticsQuestions = [
  { 
    q: 'Какая аналитика доступна?', 
    a: 'На дашборде отображается баланс, количество активных целей, статистика выполнения задач. Детальная аналитика доступна в каждом разделе: графики доходов/расходов в Финансах, прогресс целей в Целях.' 
  },
  { 
    q: 'Можно ли посмотреть статистику за период?', 
    a: 'Да! Во вкладке "Статистика" в разделе Целей вы можете выбрать период и увидеть количество выполненных задач с группировкой по месяцам.' 
  }
];

// Для лендинга - краткие FAQ
export const landingPageFAQ = [
  { q: 'Нужна ли установка?', a: 'Нет! AvatarMe — это веб-приложение, которое работает в любом браузере без установки.' },
  { q: 'Безопасны ли мои данные?', a: 'Все данные зашифрованы и доступны только вам. Мы не передаем информацию третьим лицам.' },
  { q: 'Могу ли я использовать на телефоне?', a: 'Да, интерфейс адаптирован для мобильных устройств и работает в браузере.' },
  { q: 'Как начать пользоваться?', a: 'Публичная регистрация закрыта. Вход доступен для существующих аккаунтов.' }
];
